import { render, staticRenderFns } from "./OpzioniReintegriComandi.vue?vue&type=template&id=ff7fbd90"
import script from "./OpzioniReintegriComandi.vue?vue&type=script&lang=ts"
export * from "./OpzioniReintegriComandi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff7fbd90')) {
      api.createRecord('ff7fbd90', component.options)
    } else {
      api.reload('ff7fbd90', component.options)
    }
    module.hot.accept("./OpzioniReintegriComandi.vue?vue&type=template&id=ff7fbd90", function () {
      api.rerender('ff7fbd90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OpzioniReintegriComandi.vue"
export default component.exports